module.exports = __webpack_public_path__ + "static/img/down-2.e0f367c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/down-2.jpg
// module id = hYbi
// module chunks = 51